import { useEffect, useRef } from 'react';

const usePrevious = <T>(value: T): T => {
  const prevRef = useRef<T>(value);

  useEffect(() => {
    prevRef.current = value;
  });

  return prevRef.current;
};

export default usePrevious;
